import { actionCreator } from '../helper';

enum CommonActionTypes {
  CLEAR_REDUX_STORE = 'COMMON/CLEAR_REDUX_STORE',
}

export const clearReduxStore = actionCreator(CommonActionTypes.CLEAR_REDUX_STORE);
